import { useState, useEffect } from 'react';

const Menu = () => {
    const [isOpenMenu, setIsOpenMenu] = useState(false);

    const toggleMenu = () => {
        setIsOpenMenu(!isOpenMenu);
    };

    useEffect(() => {
        if (isOpenMenu) {
            document.body.style.overflowY = 'hidden';
        } else {
            document.body.style.overflowY = '';
        }
    }, [isOpenMenu]);

    return {
        isOpenMenu,
        toggleMenu
    };
}
export default Menu;
